/* eslint-disable no-console */
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { cart } from '@/theme/Cart';
import { QuantitySelector } from '../QuantitySelector/QuantitySelector';

@Component
export class CartItem extends ThemeComponent {
    @Prop item!: Shopify.Liquid.LineItem;

    @Ref({ required: false }) quantitySelector!: QuantitySelector[];
    @Ref({ required: false }) removeItemButton!: HTMLButtonElement[];
    @Ref errorMessage!: HTMLElement;

    private errorMsg: string = '';

    init() {

        // Check if cart contains a gift card
        const hasGiftCard = cart.items.some((item) => item.handle === 'gift-card');
        const checkoutButton = document.querySelector('.cart__checkout-button') as HTMLElement;

        if (checkoutButton && hasGiftCard) {
            checkoutButton.classList.remove('button--disabled');
        }

        // Listen for item remove clicks
        for (const button of this.removeItemButton) {
            this.$listen(button, 'click', () => this.handleQuantity(0));
        }

        // Subscribe to quantity change
        for (const selector of this.quantitySelector) {
            this.$subscribe(selector.onChange, (quantity) => {
                this.handleQuantity(quantity).catch((e) => {
                    this.$log.error(`Update quantity failed`, { e });
                });
            });
        }

    }

    async handleQuantity(quantity: number) {
        console.log('handle quantity', quantity);
        // Find matching cart item
        let matchingItem = null;
        for (const item of cart.items) {
            if (item.variantId === this.item.id) {
                matchingItem = item;
            }
        }
        if (matchingItem === null) {
            this.$log.error(`No matching item found`);
            return;
        }

        // Attemp quantity update
        try {
            if (quantity === 0) {
                // Remove item
                await cart.removeItem(matchingItem);
            } else {
                // Change item
                console.log('cart change item');
                await cart.changeItem(matchingItem, quantity, null);
            }

            // Clear error if update was successful
            this.errorMsg = '';
            this.hideErrorMessage();

        } catch (event: unknown) {
            const { message } = event as Error;
            this.$log.error('Cart item quantity update error', message);
            this.errorMsg = `${message ? message.split('.')[0] : ''}`;
            this.showErrorMessage();
        }

        // Dispatch event for other components to listen to
        document.dispatchEvent(new Event('cartChanged'));
    }

    showErrorMessage() {
        const cartWrapper = document.querySelector('.cart-error');
        if (cartWrapper && this.errorMsg) {
            cartWrapper.textContent = this.errorMsg;
            cartWrapper.classList.add('show');
        }
    }

    hideErrorMessage() {
        const cartWrapper = document.querySelector('.cart-error');
        if (cartWrapper) {
            cartWrapper.textContent = '';
            cartWrapper.classList.remove('show');
        }
    }


}
